import { render, staticRenderFns } from "./Regapply.vue?vue&type=template&id=674ed24c&scoped=true"
import script from "./Regapply.vue?vue&type=script&lang=js"
export * from "./Regapply.vue?vue&type=script&lang=js"
import style0 from "./Regapply.vue?vue&type=style&index=0&id=674ed24c&prod&scoped=true&lang=css"
import style1 from "./Regapply.vue?vue&type=style&index=1&id=674ed24c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674ed24c",
  null
  
)

export default component.exports